
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confirm-payment",
      function () {
        return require("private-next-pages/confirm-payment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confirm-payment"])
      });
    }
  